var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("企业风采")]),_vm._v(" "),_c('div',{staticClass:"imgs"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"img",style:({backgroundImage:'url('+item+')'}),attrs:{"src":item}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }